import { Component } from '@angular/core';
import { INotification } from '../../models/notifications';
import { NotificationsService } from '../../services/notifications.service';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  imports: [TranslateModule, FontAwesomeModule, CommonModule]
})
export class NotificationsComponent  {

  public isShown = false;
  public data: INotification[];

  constructor(
    private notificationsService: NotificationsService,
  ) {
    this.notificationsService.isShown.subscribe(
      state => this.isShown = state,
    );
    this.notificationsService.data.subscribe(
      data => this.data = data,
    );
  }

  public toggle(event) {
    event.preventDefault();
    this.notificationsService.toggle();
  }

  public get count() {
    if (this.data) {
      return this.data.length;
    }
  }
}
